import { render, staticRenderFns } from "./fclAddonForm.vue?vue&type=template&id=5f19612b&"
import script from "./fclAddonForm.vue?vue&type=script&lang=js&"
export * from "./fclAddonForm.vue?vue&type=script&lang=js&"
import style0 from "./fclAddonForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f19612b')) {
      api.createRecord('5f19612b', component.options)
    } else {
      api.reload('5f19612b', component.options)
    }
    module.hot.accept("./fclAddonForm.vue?vue&type=template&id=5f19612b&", function () {
      api.rerender('5f19612b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFclAddon/components/fclAddonForm.vue"
export default component.exports